import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {CarePlanConfiguration} from '../../../../../../../backend/interfaces/care-plan-configuration';
import {EntityActivitiesRepository} from '../../../../../../../repositories/entity-activities';

export function useFetchActivitiesGroupTypeConfiguration(
  activitiesSectorId: string,
  activitiesGroupId: string,
  activityTypeId: string
) {
  const {entityId} = useParams<{entityId: string}>();
  const [items, setItems] = useState<CarePlanConfiguration[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    setIsLoading(true);
    EntityActivitiesRepository.instance
      .getTypeCarePlanConfigurations(
        entityId,
        activitiesSectorId,
        activitiesGroupId,
        activityTypeId
      )
      .then((data) => {
        setItems(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [activitiesGroupId, activitiesSectorId, activityTypeId, entityId]);

  return {
    items,
    isLoading,
    error,
  };
}
